import { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { Button, Table, DatePicker, Space, Select} from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable} from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

type fetchParams = {
    date: any,
    city_code: undefined | string
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        date: null,
        city_code: undefined
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    // 列表数据
    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const [cityList, setCityList] = useState<any>([])

    // 用户权限
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    useEffect(() => {
        // 查看门店城市列表
        axiosTable.get("/manage_center/store/store_city_list", {

        }).then((response: any) => {
            if (response) {
                setCityList(response)
            }
        })
    }, [])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.performance_date = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        axiosTable.get('/yuesao_center/manage/performance/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 月嫂中心 -> 月嫂管理 -> 月嫂绩效管理 */}
        <BreadCrumb position={['月嫂中心', '月嫂绩效管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <DatePicker style={{ marginRight: 8, marginBottom: 12 }} placeholder={'选择日期'} picker="month" value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="城市" value={fetchOtherParams.city_code} onChange={(v: string) => { handleChange(v, 'city_code') }}  >
                    {cityList.map((item: any) => {
                        return <Option value={item.city_code} key={item.city_code}>{item.city_name}</Option>
                    })}
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                {permission.includes('查看') && <Column
                    fixed
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button type="primary" ><Link to={"/yuesao_performance_detail/" + record.performance_id}>查看</Link></Button>
                        </Space>
                    )}
                />}

                <Column fixed title="日期" dataIndex="performance_date" key="performance_date" />
                <Column fixed title="城市" dataIndex="city_name" key="city_name" />
                <Column fixed title="门店总数" dataIndex="total_store_num" key="total_store_num" />
                <Column fixed title="员工总数" dataIndex="total_employee_num" key="total_employee_num" />
                <Column title="待审核员工数" dataIndex="pending_employee_num" key="pending_employee_num" />
                <Column title="已审核员工数" dataIndex="pass_employee_num" key="pass_employee_num" />
                <Column title="不通过员工数" dataIndex="refuse_employee_num" key="refuse_employee_num" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
                <Column title="更新时间" dataIndex="update_time" key="update_time" />
            </Table>
        </div>
    </div>)
}